import PropTypes from 'prop-types';
import React, {Component} from 'react';
import FullWidthModal from './FullWidthModal';
import {Checkbox} from 'components/forms';
import {FormattedMessage} from 'react-intl';

const propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  message: PropTypes.string,
  visible: PropTypes.bool,
  dismissKey: PropTypes.string,
  submitLabel: PropTypes.string,
};
const defaultProps = {
  visible: false,
  submitLabel: 'Merge',
};

class ConfirmationModal extends Component {
  constructor(props) {
    super(props);

    // this.submit = this.submit.bind(this);

    this.state = {
      show: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible && !this.props.visible && nextProps.dismissKey) {
      const autoSubmit = sessionStorage.getItem(nextProps.dismissKey);

      if (autoSubmit) {
        this.submit(nextProps);
      } else {
        this.setState({show: true});
      }
    } else if (!nextProps.visible && this.props.visible) {
      this.setState({show: false});
    }
  }

  submit(props = this.props) {
    let {onSubmit, dismissKey} = props;

    if (this.dismiss && this.dismiss.getChecked && dismissKey) {
      let checked = this.dismiss.getChecked();

      if (checked) {
        sessionStorage.setItem(dismissKey, checked);
      } else {
        sessionStorage.removeItem(dismissKey);
      }
    }
    return onSubmit();
  }

  render() {
    let {visible, onClose, message, submitLabel} = this.props;

    if (!visible || !this.state.show) {
      return null;
    }

    return <FullWidthModal onClose={onClose} style={{backgroundColor: '#ebebeb'}}>
      <div>
        <h1 style={{fontSize: 24, marginBottom: 25}}><FormattedMessage id='general.confirmation' /></h1>
        <p>{message}</p>
        <p className='error'><i className='bl bl-attention' />&nbsp;<FormattedMessage id='tools.update.cannot.undone' /></p>
        <div className='row' style={{marginTop: 25}}>
          <div className='col-md-6'>
            <Checkbox ref={d => this.dismiss = d} label={<FormattedMessage id='data-cleanup.warning.dismiss' />} />
          </div>

          <div className='col-md-6'>
            <div className='pull-right'>
              <button className='btn btn-default' onClick={() => onClose()}><FormattedMessage id='general.cancel' /></button>
              <button className='btn btn-primary' onClick={() => this.submit()}>{submitLabel}</button>
            </div>
          </div>
        </div>
      </div>
    </FullWidthModal>;
  }
}
ConfirmationModal.propTypes = propTypes;
ConfirmationModal.defaultProps = defaultProps;

export default ConfirmationModal;
